const PRIMARY_BACKGROUND_COLOR = '#475ddc';

export const calculateBackgroundColor = (depth, hasChildren) => {
  const baseBackgroundColor = PRIMARY_BACKGROUND_COLOR;
  if (depth === 0) {
    return baseBackgroundColor;
  }
  if (!hasChildren) {
    return '';
  }
  const opacity = 1 - (depth * 0.3);
  return `rgba(71, 93, 220, ${opacity})`;
};

export const isValidRoleName = name => {
  const specialCharPattern = /[^a-zA-Z0-9 ]/g; // Allows only letters, numbers, and spaces
  return !specialCharPattern.test(name) && name.length > 0;
};

export const arePermissionsEqual = (permissions1, permissions2) => {
  if (permissions1.length !== permissions2.length) return false;
  return permissions1.every((perm, index) => perm === permissions2[index]);
};
